import { render } from "./WaveList.vue?vue&type=template&id=51c5ba31&scoped=true"
import script from "./WaveList.vue?vue&type=script&lang=js"
export * from "./WaveList.vue?vue&type=script&lang=js"

import "./WaveList.vue?vue&type=style&index=0&id=51c5ba31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c5ba31"]])

export default __exports__